import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";
import { MdsIcon } from "@/design-system/components/icon";
import { TitleIcon } from "@/design-system/components/item-list/types";
import { css } from "@/domains/emotion";
import { MDSTooltip, MDSTooltipPlacement, MDSTooltipTrigger } from "@/mds";

interface Props {
  titleIcon: TitleIcon;
}

export const TitleIconComponent = observer(({ titleIcon }: Props) => {
  const { tooltip, kind, innerStyles } = titleIcon;

  if (!tooltip) {
    return (
      <Wrapper>
        <StyledIcon
          kind={kind}
          innerStyles={innerStyles ?? { Icon: { className: innerIconStyles } }}
        />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <MDSTooltip
        config={{
          label: tooltip,
          placement: MDSTooltipPlacement.Top,
        }}
      >
        <MDSTooltipTrigger>
          <MdsIcon kind={kind} innerStyles={innerStyles} />
        </MDSTooltipTrigger>
      </MDSTooltip>
    </Wrapper>
  );
});

const Wrapper = styled.span(({ theme }) => ({
  marginLeft: theme.spacing.xs,
  fontSize: theme.fontSizes.xxsmall,
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.xxxsmall,
  color: theme.colors.grey.x500,
}));

const StyledIcon = styled(MdsIcon)`
  height: 12px;
  width: 12px;
`;

const innerIconStyles = css`
  height: 12px;
  width: 12px;
`;
